//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import CustomAvatar from '../../../components/basic/customAvatar'

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    ListItem,
    CircularProgress
} from '@material-ui/core'
import { DateTimePicker, DatePicker } from 'material-ui-pickers'
import { IconButton, InputAdornment } from '@material-ui/core'
import CalendarToday from '@material-ui/icons/CalendarToday'

//style
import './AddEditItem.scss'

//other libraries
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'

import moment from 'moment'
import 'moment/locale/sk'
import { regexes } from '../../../functions/regexes'

//calendar
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core'
import CustomSelect from '../../../components/basic/CustomSelect'

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiInput: {
            underline: {
                '&::after': {
                    borderBottomColor: '#777777',
                    borderBottom: '2px solid #777777 !important'
                }
            }
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                // backgroundColor: lightBlue.A200,
                // color: 'white',
            }
        },
        MuiPickersClock: {
            pin: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersClockPointer: {
            pointer: {
                backgroundColor: '#FF7800'
            },
            thumb: {
                backgroundColor: '#FF7800',
                borderColor: '#FF7800'
            }
        },
        MuiPickersClockNumber: {
            selected: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersDay: {
            day: {
                color: '#777777'
            },
            selected: {
                backgroundColor: '#FF7800',
                '&:hover': {
                    backgroundColor: '#FF7800'
                }
            },
            current: {
                color: '#777777'
            }
        },
        MuiPickersYear: {
            root: {
                color: '#777777',
                '&:hover': {
                    color: '#FF7800'
                }
            },
            selected: {
                color: '#FF7800 !important',
                '&:hover': {
                    color: '#FF7800'
                }
            }
        },
        MuiPickersModal: {
            dialogAction: {
                color: '#777777'
            }
        }
    }
})

@inject('translate')
@inject('internal')
@observer
export default class AddEditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            parameterType: 0,
            loading: true,
            loadingBtn: false,
            selectedDateFrom: moment(),
            selectedDateTo: moment().add(10, 'y'),
            locale: 'sk',
            typeMenu: '',
            production: true,
            image: null,
            selectedContentPosition: 5
        }
    }

    isEditMode = null
    componentDidMount() {
        this.isEditMode = toJS(this.props.internal.actionEdit)
        if (this.isEditMode.edit) {
            this.loadDetailBanner()
        } else {
            this.setState({ loading: false })
        }
    }

    handleChangeParameterType = event => {
        this.setState({ parameterType: event.target.value })
    }

    action = () => {
        this.createUpdate()
    }

    bannerData = {}

    loadDetailBanner = async () => {
        let load_data = await api({
            method: 'get',
            url: `lists/banners/${this.isEditMode.id}`,
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success && load_data.success === true) {
            this.bannerData = load_data.data.data
            this.bannerData.button_link = load_data.data.data.button_link.replace('https://', '')
            this.setState(
                {
                    selectedDateFrom: load_data.data.data.published_from,
                    selectedDateTo: load_data.data.data.published_until,
                    production: load_data.data.data.production,
                    is_target_blank: load_data.data.data.is_target_blank,
                    image: load_data.data.data.image,
                    loading: false,
                    selectedContentPosition: load_data.data.data.banner_text_position_id
                },
                () => {
                    // this.title.setValue(load_data.data.data.title)
                    // this.subtitle.setValue(load_data.data.data.subtitle)
                    // this.button_link.setValue(load_data.data.data.button_link)
                    // this.button_title.setValue(load_data.data.data.button_title)
                }
            )
        }

        // this.setState({loading: false})
    }

    createUpdate = async () => {
        let link = this.button_link.state.value

        if (this.state.image === null) {
            this.props.internal.setSnackbar(
                this.props.translate.i18n.GLOBAL.ALERTS.IMAGE_IS_REQUIRED,
                true
            )
            return
        }

        if (!regexes.url.test(link)) {
            this.props.internal.setSnackbar(
                this.props.translate.i18n.GLOBAL.ALERTS.INCORECT_URL,
                true
            )
            return
        } else {
            link = link.replace('https://', '')
            link = link.replace('http://', '')
            link = 'https://' + link
        }

        if (
            this.button_link.state.value === '' ||
            this.button_title.state.value === '' ||
            this.title.state.value === ''
        ) {
            this.props.internal.setSnackbar(
                this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS,
                true
            )
            return
        }

        this.setState({ loadingBtn: true })
        let params = {
            button_link: link,
            button_title: this.button_title.state.value,
            is_target_blank: this.state.is_target_blank?1:0,
            // image: this.state.image, // musi byt file
            published_from: moment(this.state.selectedDateFrom).format('YYYY-MM-DD'),
            published_until: moment(this.state.selectedDateTo).format('YYYY-MM-DD'),
            subtitle: this.subtitle.state.value,
            title: this.title.state.value,
            shop_id: this.props.shop,
            banner_text_position_id: this.state.selectedContentPosition
        }

        let method = 'post'
        let url = `lists/banners`
        if (this.isEditMode.edit) {
            method = 'patch'
            let idBanner = this.isEditMode.id
            url += `/${idBanner}`

            if (typeof this.state.image !== 'string' || this.state.image instanceof String) {
                params.image = this.state.image
            }
        } else {
            params.image = this.state.image
        }

        let update_data = await api({
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            formData: true,
            formBanner: true,
            params: params
        })

        if (
            update_data.success === true ||
            (update_data.success === false && update_data.status === 201)
        ) {
            this.isEditMode.id = update_data.data.data.id
            this.updateProduction()
        } else {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.setState({ loadingBtn: false })
        }
    }

    updateProduction = async () => {
        let update_data = await api({
            method: 'patch',
            url: `lists/banners/${this.isEditMode.id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: this.state.production
            }
        })

        if (update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.setState({ loadingBtn: false })
            this.props.onClose(true)
        }
    }

    handleDateChange = (type, date) => {
        if (type === 'selectDateFrom') {
            this.setState({ selectedDateFrom: date })
        } else {
            this.setState({ selectedDateTo: date })
        }
    }

    handleChangeCheckbox = (field, event) => {
        this.setState({ [field]: event.target.checked })
    }

    handleChangeType = typeMenu => {
        this.setState({ typeMenu: typeMenu.target.value })
    }

    handleChangePhoto = data => {
        this.setState({ image: data })
        return Promise.resolve(false)
    }

    render() {
        const { selectedDateFrom, selectedDateTo, selectedContentPosition } = this.state

        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby='form-dialog-title'
                classes={{
                    paper: 'addEditMenuItemDialog'
                }}
            >
                <DialogTitle id='form-dialog-title'>{this.props.title}</DialogTitle>
                {this.state.loading ? (
                    <div style={{ minHeight: '100px' }}>
                        <CircularProgress className={'circular-progress'} />
                    </div>
                ) : (
                    // <DialogContent style={{display: "flex", flexDirection: "column"}}>
                    <DialogContent className={'dialog-content-banner'}>
                        <CustomAvatar
                            src={
                                this.state.image !== null
                                    ? this.state.image
                                    : this.props.internal.dataForSimpeTable.photo
                            }
                            // disableEdit={idAdmin === loggedUserId ? false : true}
                            actionUploadPhoto={this.handleChangePhoto}
                            additionalFileTypes="image/gif, image/webp"
                        />
                        <CustomInput
                            ref={ref => (this.title = ref)}
                            text={this.props.translate.i18n.MODULES.BANNER.TITLE}
                            // value={this.props.idCategory ? this.editCategory.name : ""}
                            value={this.isEditMode.edit ? this.bannerData.title : ''}
                            id={'title'}
                            className={'w-100'}
                            required
                        />
                        <CustomInput
                            ref={ref => (this.subtitle = ref)}
                            text={this.props.translate.i18n.MODULES.BANNER.DESCRIPTION}
                            // value={this.props.idCategory ? this.editCategory.name : ""}
                            value={this.isEditMode.edit ? this.bannerData.subtitle : ''}
                            id={'description'}
                            className={'w-100'}
                            multiline={true}
                            required
                        />
                        {/* <div className={'url-button-name'}> */}
                        <CustomInput
                            ref={ref => (this.button_link = ref)}
                            text={this.props.translate.i18n.MODULES.BANNER.URL}
                            // value={this.props.idCategory ? this.editCategory.name : ""}
                            value={this.isEditMode.edit ? this.bannerData.button_link : ''}
                            id={'url'}
                            className={'w-100'}
                            required
                            startAdornment={{
                                position: 'start',
                                value: 'https://'
                            }}
                        />
                        <CustomInput
                            ref={ref => (this.button_title = ref)}
                            text={this.props.translate.i18n.MODULES.BANNER.BUTTON_NAME}
                            // value={this.props.idCategory ? this.editCategory.name : ""}
                            value={this.isEditMode.edit ? this.bannerData.button_title : ''}
                            id={'button_name'}
                            className={'w-100'}
                            required
                        />
                        {/* @rs added text position select */}
                        <p className={'generic-label'}>
                            {this.props.translate.i18n.MODULES.BANNER.CENTER_CONTENT_BY}
                        </p>
                        <Select
                            className={''}
                            value={this.state.type}
                            onChange={e => {
                                this.setState({
                                    selectedContentPosition: parseInt(e.target.value)
                                })
                            }}
                            inputProps={{
                                name: 'position',
                                id: 'position'
                            }}
                            value={selectedContentPosition.toString()}
                        >
                            <MenuItem value={'1'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.TOP_LEFT}
                            </MenuItem>
                            <MenuItem value={'2'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.TOP_CENTER}
                            </MenuItem>
                            <MenuItem value={'3'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.TOP_RIGHT}
                            </MenuItem>
                            <MenuItem value={'4'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.MIDDLE_LEFT}
                            </MenuItem>
                            <MenuItem value={'5'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.MIDDLE_CENTER}
                            </MenuItem>
                            <MenuItem value={'6'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.MIDDLE_RIGHT}
                            </MenuItem>
                            <MenuItem value={'7'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.BOTTOM_LEFT}
                            </MenuItem>
                            <MenuItem value={'8'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.BOTTOM_CENTER}
                            </MenuItem>
                            <MenuItem value={'9'}>
                                {this.props.translate.i18n.MODULES.BANNER.POSITIONS.BOTTOM_RIGHT}
                            </MenuItem>
                        </Select>
                        <div className={'date-picker-container'}>
                            <MuiThemeProvider theme={materialTheme}>
                                <MuiPickersUtilsProvider
                                    utils={MomentUtils}
                                    locale={this.state.locale}
                                    moment={moment}
                                >
                                    <div className='date-picker'>
                                        <span>
                                            {this.props.translate.i18n.MODULES.MENU.DATE_FROM}
                                        </span>
                                        {/* <DateTimePicker
                                        okLabel={<span style={{color: "#FF7800"}}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                        cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                        autoOk
                                        ampm={false}
                                        showTabs={false}
                                        autoSubmit={false}
                                        allowKeyboardControl={false}
                                        labelFunc={date => (date ? date.format('DD.MM.YYYY HH:mm') : '')}
                                        // disableFuture
                                        // minDate={new Date("2018-01-01")}
                                        // value={this.isEditMode.edit ? this.bannerData.created_at : selectedDateFrom}
                                        value={selectedDateFrom}
                                        onChange={(date) => this.handleDateChange('selectDateFrom', date)}
                                        // helperText="Hardcoded helper text"
                                        // leftArrowIcon={<AlarmIcon />}
                                        // rightArrowIcon={<SnoozeIcon />}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton style={{padding: 6}}>
                                                        <CalendarToday />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    /> */}
                                        <DatePicker
                                            okLabel={
                                                <span style={{ color: '#FF7800' }}>
                                                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                                </span>
                                            }
                                            cancelLabel={
                                                <span>
                                                    {
                                                        this.props.translate.i18n.GLOBAL.BUTTONS
                                                            .CANCEL
                                                    }
                                                </span>
                                            }
                                            autoOk
                                            // ampm={false}
                                            showTabs={false}
                                            // autoSubmit={false}
                                            allowKeyboardControl={false}
                                            labelFunc={date =>
                                                date ? date.format('DD.MM.YYYY') : ''
                                            }
                                            // disableFuture
                                            // minDate={new Date("2018-01-01")}
                                            // value={this.isEditMode.edit ? this.bannerData.created_at : selectedDateFrom}
                                            value={selectedDateFrom}
                                            onChange={date =>
                                                this.handleDateChange('selectDateFrom', date)
                                            }
                                            // helperText="Hardcoded helper text"
                                            // leftArrowIcon={<AlarmIcon />}
                                            // rightArrowIcon={<SnoozeIcon />}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <IconButton style={{ padding: 6 }}>
                                                            <CalendarToday />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className='date-picker'>
                                        <span>
                                            {this.props.translate.i18n.MODULES.MENU.DATE_TO}
                                        </span>
                                        {/* <DateTimePicker
                                        okLabel={<span style={{color: "#FF7800"}}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                        cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                        autoOk
                                        ampm={false}
                                        showTabs={false}
                                        autoSubmit={false}
                                        allowKeyboardControl={false}
                                        // disableFuture
                                        // minDate={new Date("2018-01-01")}
                                        // value={this.isEditMode.edit ? this.bannerData.updated_at : selectedDateTo}
                                        value={selectedDateTo}
                                        onChange={(date) => this.handleDateChange('selectDateTo', date)}
                                        labelFunc={date => (date ? date.format('DD.MM.YYYY HH:mm') : '')}
                                        // helperText="Hardcoded helper text"
                                        // leftArrowIcon={<AlarmIcon />}
                                        // rightArrowIcon={<SnoozeIcon />}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton style={{padding: 6}}>
                                                        <CalendarToday />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    /> */}
                                        <DatePicker
                                            okLabel={
                                                <span style={{ color: '#FF7800' }}>
                                                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                                </span>
                                            }
                                            cancelLabel={
                                                <span>
                                                    {
                                                        this.props.translate.i18n.GLOBAL.BUTTONS
                                                            .CANCEL
                                                    }
                                                </span>
                                            }
                                            autoOk
                                            // ampm={false}
                                            showTabs={false}
                                            // autoSubmit={false}
                                            allowKeyboardControl={false}
                                            // disableFuture
                                            // minDate={new Date("2018-01-01")}
                                            // value={this.isEditMode.edit ? this.bannerData.updated_at : selectedDateTo}
                                            value={selectedDateTo}
                                            onChange={date =>
                                                this.handleDateChange('selectDateTo', date)
                                            }
                                            labelFunc={date =>
                                                date ? date.format('DD.MM.YYYY') : ''
                                            }
                                            // helperText="Hardcoded helper text"
                                            // leftArrowIcon={<AlarmIcon />}
                                            // rightArrowIcon={<SnoozeIcon />}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <IconButton style={{ padding: 6 }}>
                                                            <CalendarToday />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </MuiPickersUtilsProvider>
                            </MuiThemeProvider>
                        </div>
                        <ListItem
                            dense
                            onChange={e => this.handleChangeCheckbox('production', e)}
                            className={'list-item'}
                        >
                            <input
                                id={'production'}
                                type='checkbox'
                                value={this.state.production}
                                defaultChecked={this.state.production}
                            />
                            <label htmlFor={'production'}>
                                {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                            </label>
                        </ListItem>
                        <ListItem
                            dense
                            onChange={e => this.handleChangeCheckbox('is_target_blank', e)}
                            className={'list-item'}
                        >
                            <input
                                id={'is_target_blank'}
                                type='checkbox'
                                value={this.state.is_target_blank}
                                defaultChecked={this.state.is_target_blank}
                            />
                            <label htmlFor={'is_target_blank'}>
                                {this.props.translate.i18n.MODULES.BANNER.OPEN_ON_NEW_TAB}
                            </label>
                        </ListItem>
                    </DialogContent>
                )}
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/banner/AddEditItem/AddEditItem.jsx